import React, {useEffect, useState, useRef} from 'react';
import { NavLink } from 'react-router-dom';
import './NavegationLinks.css';
import CallUsButton from '../../../UiElements/CallUsButton/CallUsButton';

const NavLinks = props => {

  const [showLoginMenu, setShowLoginMenu] = useState(false);
  const [showBlogsMenu, setShowBlogsMenu] = useState(false);
  const loginMenuRef = useRef(null);
  const blogsMenuRef = useRef(null);

  let styles = {
    borderBottom: '3px solid #73B4FF',
  };
  
  const [activeLink, setActiveLink] = useState(`${sessionStorage.getItem('sectionName') === 'home' ? 'home' : sessionStorage.getItem('sectionName') === 'price' ? 'price'  : 
  window.location.pathname === '/cancel-service' || 
  window.location.pathname === '/privacy-policy' || 
  window.location.pathname ==='/refund-policy' || 
  window.location.pathname ==='/terms-of-service' ? 'home' : window.location.pathname === '/checkout' ? 'price' : ''}`);
  
  const handleHomeClick = () => {
    setActiveLink('');
    window.scrollTo(0, 0);
    sessionStorage.clear();
  };

  const toggleLoginMenu = () => {
    setShowBlogsMenu(false);
    setShowLoginMenu(prev => !prev);
  };

  const toggleBlogsMenu = () => {
    setShowLoginMenu(false);
    setShowBlogsMenu(prev => !prev);
  };

  // Nuevo manejador específico para la flecha
  const handleArrowClick = (e) => {
    e.stopPropagation(); // Esto previene que el evento se propague al botón padre
    setShowLoginMenu(prev => !prev);
  };

  const handleBlogsArrowClick = (e) => {
    e.stopPropagation();
    setShowBlogsMenu(prev => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (loginMenuRef.current && !loginMenuRef.current.contains(event.target)) {
        setShowLoginMenu(false);
      }

      if (blogsMenuRef.current && !blogsMenuRef.current.contains(event.target)) {
        setShowBlogsMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <React.Fragment>
      <ul className="nav-links" >
        <li>
          <NavLink to="/" onClick={handleHomeClick} style={activeLink === 'home' ? styles : {}} exact>HOME</NavLink> 
        </li>

        <li>
          <NavLink to="/about-us" onClick={handleHomeClick}>ABOUT US</NavLink>  
        </li>

        <li>
          <NavLink to="/price" onClick={handleHomeClick} style={activeLink === 'price' ? styles : {}}>PRICE</NavLink>
        </li>

        <li>
          <NavLink to="/contact" onClick={handleHomeClick}>CONTACT</NavLink>
        </li>

        <li>
          <NavLink to="/cancel-service" onClick={handleHomeClick}>CANCEL</NavLink>
        </li>

        <li className="login-dropdown" ref={blogsMenuRef}>
          <button type="button" onClick={toggleBlogsMenu}>
            BLOGS
            <span
              className="login-arrow"
              onClick={handleBlogsArrowClick}
            >
              {showBlogsMenu ? "▾" : "▸"}
            </span>
          </button>

          {showBlogsMenu && (
            <ul className="login-submenu">
              <li>
                <a href="https://whatis.idguardllc.com/" target="_blank" rel="noopener noreferrer">What is ID Guard?</a>
              </li>
              <li>
                <a href="https://benefits.idguardllc.com/" target="_blank" rel="noopener noreferrer">Benefits</a>
              </li>
            </ul>
          )}
        </li>



        <li className="login-dropdown" ref={loginMenuRef}>
          <button type="button" onClick={toggleLoginMenu}>
            LOGIN 
            <span 
              className="login-arrow" 
              onClick={handleArrowClick} // Usamos el nuevo manejador
            >
              {showLoginMenu ? "▾" : "▸"}
            </span>
          </button>
          
          {showLoginMenu && (
            <ul className="login-submenu">
              <li>
                <a href="https://portal.idguardllc.com/" target="_blank" rel="noopener noreferrer">Legacy portal</a>
              </li>
              <li>
                <a href="https://idguard.idcommandcenter.com/" target="_blank" rel="noopener noreferrer">New portal</a>
              </li>
            </ul>
          )}
        </li>

        <li className='NavLinks__call-us-button-link'>
          <CallUsButton phonenumber="CALL NOW"/>
        </li> 
      </ul>
    </React.Fragment>
  );
};

export default NavLinks;